import React from "react";

const LegalResponsibility = () => (
  <section className="w-full bg-white py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">5. Responsabilité</h2>
    <p className="text-light-1 leading-relaxed">
      NextMaker met tout en œuvre pour assurer l’exactitude et la mise à jour des informations publiées. 
      Cependant, le site peut contenir des erreurs ou omissions. NextMaker ne saurait être tenu responsable 
      de l’usage qui en est fait par les utilisateurs.
    </p>
    <p className="text-light-1 mt-3">
      Des liens externes peuvent rediriger vers d’autres sites : NextMaker n’est pas responsable du contenu de ces sites tiers.
    </p>
  </section>
);

export default LegalResponsibility;
